// removed by extract-text-webpack-plugin
module.exports = {"wowCampaign":"wowCampaign__38gr9","wowCampaignResult":"wowCampaignResult__1lY35","wowCampaignSuccessTip":"wowCampaignSuccessTip__1Gp2k","wowCampaignFailureTip":"wowCampaignFailureTip__GiBUC","wowCampaignUserAvatar":"wowCampaignUserAvatar__9948R","wowCampaignUserName":"wowCampaignUserName__3WqcS","wowCampaignUserBadge":"wowCampaignUserBadge__2EbJW","wowCampaignSuccessDesc":"wowCampaignSuccessDesc__1LEsJ","wowCampaignProfileButton":"wowCampaignProfileButton__1VABc","wowCampaignRetryButton":"wowCampaignRetryButton__3jHPC"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Campaign/Wow/index.css
// module id = 1580
// module chunks = 0